import { render, staticRenderFns } from "./PermissionEditView.vue?vue&type=template&id=697b5da6&"
import script from "./PermissionEditView.vue?vue&type=script&lang=js&"
export * from "./PermissionEditView.vue?vue&type=script&lang=js&"
import style0 from "./PermissionEditView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports